<template>
    <div class="container-fluid">
        <Breadcrumb title="Email Lists" button-url="emailListCreate"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group">
                                <treeselect placeholder="Search by category"
                                            v-model="categorySearch"
                                            :multiple="false"
                                            :options="categoryList"
                                            :load-options="loadCategoryList"
                                />
                            </div>
                            <input v-model="emailListSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="emailLists.length > 0">
                                <div class="table-responsive">
                                    <table class="table table-header-rotated">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Total</th>
                                            <th>Valid</th>
                                            <th class="rotate-45" v-for="(mailProvider, index) in mailProviders"
                                                :key="index">
                                                <span>{{mailProvider.name}}</span>
                                            </th>
                                            <th>Created</th>
                                            <th>Uploading</th>
                                            <th v-if="isAdmin">Users</th>
                                            <th v-if="isAdmin">Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(emailList, index) in emailLists" :key="index">
                                            <td class="align-middle">{{emailList.id}}</td>
                                            <td class="align-middle">{{emailList.name}}</td>
                                            <td class="align-middle">
                                                <span v-tooltip.top="'Total'">
                                                    {{emailList.totalCounter}}
                                                </span>
                                            </td>
                                            <td class="align-middle">
                                                <span v-tooltip.top="'Valid'">
                                                    {{emailList.validCounter}}
                                                </span>
                                            </td>
                                            <td class="align-middle"
                                                v-for="(mailProvider, index) in mailProviders"
                                                :key="index">
                                                <span v-tooltip.top="mailProvider.name">
                                                    {{ emailList[mailProvider.name] || 0 }}
                                                </span>
                                            </td>
                                            <td class="align-middle">
                                                {{moment(emailList.created_at.date.toString()).format('D.M.Y')}}
                                            </td>
                                            <td class="align-middle">
                                                {{emailList.job !== null ? 'Processing' : 'Done'}}
                                            </td>
                                            <td v-if="isAdmin" class="align-middle">
                                                <span class="px-3 badge"
                                                      v-bind:class="{'badge-light': emailList.usersCount ===0, 'badge-info': emailList.usersCount >0}">
                                                    {{emailList.usersCount}}
                                                </span>
                                            </td>
                                            <td v-if="isAdmin" class="align-middle">
                                                <router-link
                                                        :to="{ name: 'emailListManage', params: { id: emailList.id }}"
                                                        class="btn btn-success btn-sm m-r-15"
                                                        v-tooltip.top="'Manage'">
                                                    <i class="fa fa-cog"></i> Manage
                                                </router-link>
                                                <button
                                                        class="btn btn-danger btn-sm m-r-15"
                                                        @click="deleteEmailList(emailList.id)"
                                                        v-tooltip.left="'Delete'">
                                                    <i class="fa fa-minus-circle"></i> Delete
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate
                                        v-if="pageCount > 1"
                                        v-model="page"
                                        :page-count="pageCount"
                                        :page-range="3"
                                        :margin-pages="2"
                                        :click-handler="getItems"
                                        :prev-text="'Prev'"
                                        :next-text="'Next'"
                                        :container-class="'pagination justify-content-center'"
                                        :page-class="'page-item'"
                                        :page-link-class="'page-link'"
                                        :prev-class="'page-item'"
                                        :prev-link-class="'page-link'"
                                        :next-class="'page-item'"
                                        :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import EmailListService from '../services/EmailListService';
    import Preloader from '../components/Preloader';
    import CategoryService from '../services/CategoryService';
    import Breadcrumb from '../components/Breadcrumb';
    import Treeselect from '@riophae/vue-treeselect';
    import config from '../config';
    import paginateMixin from '../mixins/paginate-mixin';
    import {mapGetters} from 'vuex';
    import MailProviderService from '../services/MailProviderService';

    export default {
        name: 'EmailLists',
        components: {
            Breadcrumb,
            Preloader,
            Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                dataProgress: null,
                categoryList: null,
                categorySearch: null,
                emailListSearch: null,
                emailLists: [],
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                loading: false,
                isAdmin: false,
                config: config,
                mailProviders: [],
            };
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            this.getMailProviders();
            this.getItems(this.page = 1);
            this.emailListUploadProgress();
        },
        methods: {
            search() {
                this.getItems(this.page = 1);
            },
            loadCategoryList({callback}) {
                CategoryService.getCategorySelect().then(response => {
                    this.categoryList = response.data['hydra:member'].map(category => {
                        return {id: category.id, label: category.name}
                    });
                    callback();
                });
            },
            emailListUploadProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadEmailListProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadEmailListProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadEmailListProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadEmailListProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.emailListId !== undefined) {
                        let index = this.emailLists.findIndex(obj => obj.id === data.emailListId);
                        if (this.emailLists[index] !== undefined) {
                            this.emailLists[index].completion = parseInt(data.completion);
                            this.emailLists[index].job = parseInt(data.jobId);
                        }
                    }
                }
            },
            deleteEmailList(id) {
                Swal({
                    title: 'Are you sure you want to delete?',
                    inputAttributes: {
                        autocapitalize: "off"
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return EmailListService.deleteEmailList(id)
                            .then((response) => {
                                if (response.status === 204) {
                                    let emailGroupIndex = this.emailLists.findIndex(obj => obj.id === id);
                                    this.emailLists.splice(emailGroupIndex, 1);
                                }
                                if (response.status === 500) {
                                    Swal({
                                        type: 'warning',
                                        title: 'Attention!',
                                        text: response.data.error
                                    });
                                    return false;
                                }
                            })
                            .catch(error => {
                                Swal.showValidationMessage(`Request failed: ${error}`);
                            });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then(result => {
                    if (result.value) {
                        Swal(
                            'Deleted successfully!',
                            `Email List has been deleted.`,
                            'success'
                        );
                    }
                });
            },
            getItems: function (pageNum) {
                this.loading = true;
                EmailListService.getEmailLists(pageNum, this.perPage, this.emailListSearch, this.categorySearch)
                    .then(response => {
                        this.emailLists = response.data.items;
                        this.emailLists.forEach((emailList, index) =>
                            emailList.providersCounters.forEach( providerCounter =>
                                this.emailLists[index][providerCounter.mailProviderName] = providerCounter.counter
                            )
                        );
                        this.totalItems = response.data.totalItems;
                        this.loading = false;
                    })
                    .catch(error => {
                        Swal({
                            type: 'error',
                            title: 'Oops...',
                            text: `${error}`
                        });
                        this.loading = false;
                    });
            },
            getMailProviders() {
                MailProviderService.getProviderSelect().then(response => {
                    this.mailProviders = response.data['hydra:member'].map(provider => {
                        return {id: provider.id, name: provider.name}
                    });
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            },
            ...mapGetters({mercureListen: 'listen'})
        }
    };
</script>

<style scoped>
    .table-header-rotated th.rotate-45 {
        height: 100px;
        position: relative;
        vertical-align: bottom;
        padding: 0;
        font-size: 12px;
    }

    .table-header-rotated th.rotate-45 span {
        -ms-transform: rotate(270deg);
        -moz-transform: rotate(270deg);
        -webkit-transform: rotate(270deg);
        -o-transform: rotate(270deg);
        transform: rotate(270deg);
        position: absolute;
        bottom: 40px;
        left: -25px;
        width: 85px;
    }
</style>
